import { useEffect, useMemo } from "react";
import TableView, { ColumnConfig, FetchParams } from "../../components/controls/table-view";
import { TableContainer, TextContainer } from "../../styles/shared/table";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { setCurrentPage } from "../../store/features/authentication/user-slice";
import { deleteProductOverride, fetchProductOverrides, resetProductOverrides } from "../../store/features/supplier/supplier-product-slice";
import Button from "../../components/controls/button";
import { ProductContainer, ProductImage, ProductNameContainer, ProductTitle } from "../../styles/shared/product";
import { GoogleIcon, ICON_ID, ICON_SIZES } from "../../components/icons/google-icon";
import Image from "../../components/controls/image";

export default function AdminOverrides() {
  const dispatch = useAppDispatch();
  const productOverrides = useAppSelector((state) => state.supplierProducts.productOverrides);

  useEffect(() => {
    dispatch(setCurrentPage("Product Overrides"));

    return () => {
      dispatch(resetProductOverrides());
    };
  }, [dispatch]);

  const fetchMoreData = async (fetchParams: FetchParams) => {
    await dispatch(fetchProductOverrides({ fetchParams }));
  };

  const renderActionButton = (row: any) => (
    <Button
      id={`removeOverride_${row.id}`}
      variant="text"
      isWarning
      label="Remove Override"
      onClick={async () => {
        await dispatch(deleteProductOverride({ productOverrideId: row.id }));
      }}
    />
  );

  const columnConfig: { [key: string]: ColumnConfig } = useMemo(() => ({
    id: {
      hidden: true,
    },
    productId: {
        hidden: true,
    },
    productName:{
        hidden:true
    },
    productImage: {
        name: "Product",
        order:1,
        render: (value: string, row: any) => (
             <ProductContainer>
                      <ProductImage>
                        {row.productId ? (
                          <Image image={value}></Image>
                        ) : (
                          <GoogleIcon
                            tooltip="Not mapped"
                            id={ICON_ID.QuestionMark}
                            isWarning
                            size={ICON_SIZES.Large}
                          />
                        )
                        }
                      </ProductImage >
                      <ProductNameContainer>
                        <ProductTitle>
                          {row.productName || "-"}
                        </ProductTitle>
                        </ProductNameContainer>
            </ProductContainer>
        ),
    },
    supplierName: {
      name: "Supplier",
      order: 2,
      render: (value: string) => <TextContainer>{value || "-"}</TextContainer>,
    },
    supplierId:{
        hidden:true
    },
    expiresOn: {
      hidden: true,
    },
  }), []);

  return (
    <TableContainer>
      <TableView
        id="tblProductOverrides"
        emptyText="No product overrides"
        fetchData={fetchMoreData}
        totalCount={productOverrides?.count ?? 0}
        data={productOverrides?.overrides ?? []}
        columnConfig={columnConfig}
        actionButton={renderActionButton}
        showHeaders={true}
      />
    </TableContainer>
  );
}
